import { memo } from 'react';

import cn from 'classnames';

import BigScreen from './BigScreen';
import VideoBox from '../../VideoBox';
import VideosSidebar from './VideosSidebar';

import useVideosContainer from '../useVideosContainer';

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

import './VideosContainerScreen.scss';

const VideosContainerScreen = () => {
  const {
    sortedVideos,
    grid,
    pinVideo,
    selectedLayout,
    videosContainerRef,
    isWhiteboardActive,
    shouldShowSidebar,
    shouldShowBigScreen,
    shouldShowInstructorLayout,
    getStartIndex,
    shouldShowPagination,
    mainVideo,
    shouldShowVerticalBar,
    currentPage,
    hasNext,
    hasPrev,
    onNextHandler,
    onPrevHandler,
  } = useVideosContainer();

  return (
    <div className="main-screen-container">
      <div
        className={cn('videos-screen-container', {
          'vertical-bar-layout': shouldShowVerticalBar,
          'bottom-bar-layout': selectedLayout === 'BOTTOM_BAR',
        })}
      >
        {shouldShowVerticalBar && <VideosSidebar videos={sortedVideos.slice(getStartIndex())} />}

        {shouldShowBigScreen && (
          <BigScreen
            isWhiteboardActive={isWhiteboardActive}
            whiteboardWidth="full"
            videoBox={mainVideo}
            selectedLayout={selectedLayout}
          />
        )}

        {shouldShowInstructorLayout && (
          <div className="active-instructor-container">
            <VideoBox {...sortedVideos[getStartIndex()]} style={{ maxWidth: 'unset', height: '100%' }} />
          </div>
        )}

        {shouldShowSidebar && (
          <VideosSidebar videos={sortedVideos.slice(!isWhiteboardActive && !pinVideo ? 1 : 0)} isVertical />
        )}

        {shouldShowPagination && !!currentPage.length && (
          <div className={`videos-wrapper`}>
            {hasPrev && (
              <button onClick={onPrevHandler} className={`arrow-button ${pinVideo ? 'arrow-top' : 'arrow-left'}`}>
                <MdKeyboardArrowLeft />
              </button>
            )}
            <div
              className={`video-media-container ${!!pinVideo ? 'collapsed' : ''}`}
              ref={videosContainerRef}
              style={
                {
                  '--grid-cols': grid.cols,
                  flexWrap: Math.ceil(currentPage.length / grid.cols) === 1 ? 'nowrap' : 'wrap',
                } as React.CSSProperties
              }
            >
              {currentPage.map((videoStream) => {
                return (
                  <VideoBox
                    {...videoStream}
                    key={`${videoStream.peerId}-${videoStream.type}`}
                    style={{
                      width: grid.boxWidth,
                      height: grid.boxHeight,
                      flexBasis: grid.boxWidth,
                      maxWidth: `calc((100% - (${grid.cols - 1} * 8px)) / ${grid.cols})`,
                    }}
                  />
                );
              })}
            </div>
            {hasNext && (
              <button onClick={onNextHandler} className={`arrow-button  ${pinVideo ? 'arrow-bottom' : 'arrow-right'}`}>
                <MdKeyboardArrowRight />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(VideosContainerScreen);
